import { ApolloQueryResult } from '@apollo/client';
import { FeatureFlags } from '@buy-viasat/types/build/bv';
import gql from 'graphql-tag';
import { client } from '../../../containers/apollo';

export const FEATURE_FLAGS = gql`
  query getFeatureFlags {
    getFeatureFlags {
      maintenanceMode
      enableFiber
      enableUnleashedMax
      enableCAFContent
    }
  }
`;

export default async function getFeatureFlags(): Promise<ApolloQueryResult<{ getFeatureFlags: FeatureFlags }>> {
  return client.query({
    query: FEATURE_FLAGS,
    fetchPolicy: 'no-cache',
  });
}
